<template>
    <v-container grid-list-xl fluid>
        <v-layout row wrap>
            <v-flex lg12>
                <v-card>
                    <hpo-filter :headers="headers" :viewName="viewName" :view_filters="view_filters"
                        v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                    <v-data-table :headers="headers" :items="wulius" :options.sync="pagination"
                        :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true"
                        :loading="loading">
                        <template v-slot:item="{ item }">
                            <tr :id="'r-' + item.ID">
                                <td>{{ item.ID }}</td>
                                <td>{{ item.TransactionCode }}</td>
                                <td>{{ item.CustomerName }}</td>
                                <td>{{ item.SaleName }}</td>
                                <td>{{ item.ProductName }}</td>
                                <td>{{ item.ProductCode }}</td>
                                <td class="text-right">{{ item.Weight | currency('', 1) }}</td>
                                <td class="text-right">{{ item.Volume | currency('', 2) }}</td>
                                <td class="text-right">{{ item.Qty }}</td>
                                <td class="text-right" :style="{'color': item.Deposit ? 'rgb(32, 165, 58)' : ''}">{{ item.Deposit | currency('', 1) }}</td>
                                <td>
                                    {{ item.CreatedDate | display_date }}
                                </td>
                                <td>
                                    {{ item.TruckCreatedDate | display_date }}
                                </td>
                                <td class="text-center">
                                    <v-icon medium class="mr-2" @click="openItem(item.ID)">edit</v-icon>
                                    <!-- <v-icon medium @click="deleteItem(item.ID)">delete</v-icon> -->
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>

        <!-- Dialog Wuliu Component -->
        <wuliu-dialog
          v-model="dialogItem"
          :wuliu-id="currentWuliuId"
          @save="handleSaveWuliu"
          @close="handleCloseWuliu"
        />
    </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
import { sendErrorNotice, sendSuccessNotice } from "@/commons/utils";
import Filtering from "@/components/Filtering";
import WuliuDialog from "@/components/WuliuDialog";
import createPermissionMixin from "@/mixins/permissionMixin";

export default {
    mixins: [createPermissionMixin('wuliu_list')],
    components: {
        "hpo-filter": Filtering,
        WuliuDialog
    },
    data() {
        return {
            dialogItem: false,
            currentWuliuId: null,
            pagination: _.cloneDeep(configs.PAGINATION),
            items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
            headers: [
                { text: 'ID', value: 'ID', width: '80px', filterable: true, quickSearch: true, dataType: configs.DATA_TYPE["Number"] },
                { text: 'Mã wuliu / 运单号', value: 'TransactionCode', width: '150px', filterable: true, quickSearch: true, dataType: configs.DATA_TYPE["String"] },
                { text: 'Khách hàng / 唛头', value: 'CustomerName', width: '150px', filterable: true, quickSearch: true, dataType: configs.DATA_TYPE["String"] },
                { text: 'Nhân viên sale / 销售员', value: 'SaleName', width: '150px', filterable: true, quickSearch: true, dataType: configs.DATA_TYPE["String"] },
                { text: 'Tên hàng / 货名', value: 'ProductName', width: '120px', filterable: true, quickSearch: false, values: [], dataType: configs.DATA_TYPE["Enum"] },
                { text: 'Mã bốc / 装货编号', value: 'ProductCode', width: '120px', filterable: true, quickSearch: true, dataType: configs.DATA_TYPE["String"] },
                { text: 'Cân nặng / 重量', value: 'Weight', align: 'end', width: '100px', filterable: true, quickSearch: false, dataType: configs.DATA_TYPE["Number"] },
                { text: 'Thể tích / 体积', value: 'Volume', align: 'end', width: '100px', filterable: true, quickSearch: false, dataType: configs.DATA_TYPE["Number"] },
                { text: 'SL / 数量', value: 'Qty', align: 'end', width: '60px', filterable: true, quickSearch: false, dataType: configs.DATA_TYPE["Number"] },
                { text: 'Chi tệ / 支出金额', value: 'Deposit', align: 'end', width: '100px', filterable: true, quickSearch: false, dataType: configs.DATA_TYPE["Number"] },
                { text: 'Ngày nhập / 入库日期', value: 'CreatedDate', width: '150px', filterable: true, quickSearch: false, dataType: configs.DATA_TYPE["Date"] },
                { text: 'Ngày bốc / 装货日期', value: 'TruckCreatedDate', width: '150px', filterable: true, quickSearch: false, dataType: configs.DATA_TYPE["Date"] },
                { text: 'Thao tác / 操作', value: 'actions', sortable: false, align: 'center', width: '120px' }
            ],
            statusList: configs.PRODUCT_STATUS_LIST,
            viewName: "wuliu_list",
            filterConditions: [],
            quickFilterConditions: []
        };
    },
    computed: {
        ...mapState({
            wulius: state => state.wuliu.all.data || [],
            total_rows: state => state.wuliu.all.total || 0,
            loading: state => state.wuliu.loading,
            customers: state => state.commons.customers || [],
            product_types: state => state.productType.all.data || []
        })
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                this.filter_data();
            },
            deep: true
        },
    },
    methods: {
        filter_data: function () {
            var param = {
                pagination: this.pagination,
                search_term: this.search,
                filter: this.filterConditions,
                quickFilter: this.quickFilterConditions
            };
            this.$store.dispatch("wuliu/getList", param);
        },
        applyFilter(filterConditions) {
            let sortBy = this.pagination.sortBy
            let sortDesc = this.pagination.sortDesc
            this.pagination = configs.PAGINATION;
            this.pagination.sortBy = sortBy;
            this.pagination.sortDesc = sortDesc;
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
        openItem(id) {
            this.currentWuliuId = id > 0 ? id : null;
            this.dialogItem = true;
        },
        deleteItem(id) {
            this.$root.$emit('REQUEST_DELETE_DATA', id);
        },
        handleCloseWuliu() {
            this.dialogItem = false;
            this.currentWuliuId = null;
        },
        async handleSaveWuliu({ formData, editingWuliuId }) {
            try {
                await this.$store.dispatch('wuliu/setDetail', {
                    data: {
                        ...formData,
                        packages: JSON.stringify(formData.packages)
                    },
                    id: editingWuliuId || 0
                });

                sendSuccessNotice(this, editingWuliuId ? 'Cập nhật thành công' : 'Lưu thành công');
                this.dialogItem = false;
                this.currentWuliuId = null;
                this.filter_data();
            } catch (error) {
                sendErrorNotice(this, 'Có lỗi xảy ra: ' + error.message);
            }
        }
    },
    mounted() {
        this.$store.dispatch('commons/getAllCustomer');
        this.$store.dispatch('productType/getList');
        this.filter_data();
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$on("REQUEST_CREATE_DATA", this.openItem);
        this.$root.$on('CONFIRMED_REMOVE_DATA', id => {
            this.$store.dispatch('wuliu/removeDetail', id).then(() => {
                sendSuccessNotice(this, 'Xóa thành công');
                this.filter_data();
            }).catch(error => {
                sendErrorNotice(this, 'Có lỗi xảy ra: ' + error.message);
            });
        });
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_CREATE_DATA");
        this.$root.$off("REQUEST_REFRESH_DATA");
        this.$root.$off('CONFIRMED_REMOVE_DATA');
    }
};
</script>
